import { HeartOutlined, InfoCircleOutlined, TeamOutlined } from "@ant-design/icons";
import { Button, Tag, Tooltip } from "antd";
import React, { } from "react";
import Container from "../General/Container/Container";
import { BsGenderAmbiguous } from "react-icons/bs";
import { GiAges } from "react-icons/gi";
import { getClassType, getGenderDistribution, getHighestAge, getInterestLevel } from "../../utils/minified/MinifiedHelper";

const MinifiedDetails = (props) => {
    const {
        className = "dcol",
        itemId = "he",
        data = {
            name: "Audience 1",
            targetSize: 14003,
            targetAudience: "Nike",
            list: []
        },
        showInfo = true,
        onClickAgeGender = () => { }
    } = props

    const classTypeVal = getClassType(itemId)

    return <Container className={`minified-details ${className}`}>
        {props.children}
        <Container className="drow align-start">
            <Tag icon={<TeamOutlined />} className="minified-details-tag label">Target Audience:</Tag>
            <Tag className={"minified-details-tag" + classTypeVal}>{data.targetAudience}</Tag>
        </Container>
        <Container className="drow align-start">
            <Tag icon={<HeartOutlined />} className="minified-details-tag label">Interest level:</Tag>
            <Tag style={{ textOverflow: "hidden" }} className={"minified-details-tag" + classTypeVal}>{getInterestLevel(itemId)}</Tag>
        </Container>
        {showInfo ?
            <>
                {/* <Container className="drow align-center">
                    <Tag icon={<BsGenderAmbiguous style={{
                        marginLeft: "-3px",
                        marginRight: "6px",
                        width: "16px",
                        height: "16px"
                    }} />} className="minified-details-tag label">Gender Distribution:</Tag>
                    <Tag style={{ textOverflow: "hidden" }} className={"minified-details-tag" + classTypeVal}> */}
                        {/* {getGenderDistribution(data)} */}
                        {/* <Tooltip placement="bottom" overlayClassName="tooltip-gender"
                            className="minified-details-gendertooltip" title={
                                <Container className="dcol">
                                    <span>Gender Distribution is based from Google's Vertex AI.</span>
                                    <Button type="link" className="minified-details-gendertooltip-action"
                                        onClick={onClickAgeGender}>Explore more</Button>
                                </Container>
                            }>
                            <InfoCircleOutlined style={{ cursor: "pointer", color: "var(--bluegray-400)" }} />
                        </Tooltip>
                    </Tag>
                </Container> */}
                <Container className="drow align-center">
                    <Tag icon={<GiAges style={{
                        marginLeft: "-2px",
                        marginRight: "6px",
                        width: "16px",
                        height: "16px"
                    }} />} className="minified-details-tag label">Age Distribution:</Tag>
                    <Tag style={{ textOverflow: "hidden" }} className={"minified-details-tag" + classTypeVal}>
                        {/* {getHighestAge(data)} */}
                        <Tooltip placement="bottom" overlayClassName="tooltip-age"
                            className="minified-details-agetooltip" title={
                                <Container className="dcol">
                                    <span>Age distribution data are provided by Google™.</span>
                                    <Button type="link" className="minified-details-agetooltip-action"
                                        onClick={onClickAgeGender}>Explore more</Button>
                                </Container>
                            }>
                            <InfoCircleOutlined style={{ cursor: "pointer", color: "var(--bluegray-400)" }} />
                        </Tooltip>
                    </Tag>
                </Container></>
            : ""}
    </Container>
}

export default MinifiedDetails